import type { SearchResponse } from "@replicate/ui";

export interface SearchPrototypeResult {
  avatar_url: string | null;
  name: string;
  description: string;
  model_description: string;
  tags: string[];
  last_updated: string;
  similarity_score: number;
  recency_boost: number;
  runs_boost: number;
  rerank_boost: number;
  official_boost: number;
  aa_score: number;
  aa_boost: number;
  aa_rank: number | null;
  aa_category: string | null;
  // OFFICIAL_MODEL_AUDIT(aron)
  is_official: boolean;
  combined_score: number;
  age_days: number;
  run_count: number;
  cover_image_url: string;
  vector_score: number;
  vector_rank: number;
  fts_score: number;
  fts_rank: number;
  has_vector: boolean;
  has_fts: boolean;
  fts_owner_score: number;
  fts_description_score: number;
  hybrid_score: number;
}

export interface SearchPrototypeResponse {
  query: string;
  results: SearchPrototypeResult[];
  count: number;
  query_prefix: string;
  query_suffix: string;
}

export async function searchMicroservice(
  baseUrl: string,
  query: string
): Promise<SearchResponse> {
  const url = new URL("/query", baseUrl);

  // Set default parameters from production endpoint
  url.searchParams.set("q", query);
  url.searchParams.set("limit", "50");

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(
      `Failed to fetch search prototype results: ${res.statusText}`
    );
  }

  return await res.json();
}
